import { getText } from 'src/ConsentManagement/TranslationService';
import { ConsentEventType } from 'src/Shared/EventPublisher/ConsentEventType';
import { Publish } from 'src/Shared/EventPublisher/EventEmitter';

export const VendorsLink = ({ translationPrefix }: { translationPrefix: string }) => {
  return (
    <a
      href="#"
      class="vendors_link"
      onClick={() => {
        Publish(ConsentEventType.REQUEST_SHOW_VENDORS_LAYER);
      }}
    >
      {getText(`${translationPrefix}_vendors_link_name`)}
    </a>
  );
};
